module.exports = __webpack_public_path__ + "static/media/Webdev.3521416d.svg";